export default function ThinHoverArrow({ ...props }) {
  return (
    <svg viewBox="0 0 40 40" {...props}>
      <g transform="rotate(-90 -403 513)" fill="none">
        <g>
          <path d="M90 922.25v27.5" />
          <path d="M78.75 938.5 90 949.75l11.25-11.25" />
        </g>
      </g>
    </svg>
  );
}
